import type { ReactNode } from "react";
import {
  PDF_PAGE_HEIGHT_PX,
  PDF_PAGE_PADDING_PX,
  PDF_PAGE_WIDTH_PX,
} from "./pdfDimensions";

type PdfPageProps = {
  pageNumber: number;
  children: ReactNode;
  dark?: boolean;
  className?: string;
  centered?: boolean;
};

export function PdfPage({
  pageNumber,
  children,
  dark = false,
  className = "",
  centered = false,
}: PdfPageProps) {
  return (
    <div
      data-pdf-page={pageNumber}
      id={`pdf-page-${pageNumber}`}
      className={`pdf-page ${dark ? "pdf-page--dark" : "pdf-page--light"} ${centered ? "pdf-page--centered" : ""} ${className}`}
      style={{
        width: PDF_PAGE_WIDTH_PX,
        height: PDF_PAGE_HEIGHT_PX,
        minWidth: PDF_PAGE_WIDTH_PX,
        minHeight: PDF_PAGE_HEIGHT_PX,
        maxWidth: PDF_PAGE_WIDTH_PX,
        maxHeight: PDF_PAGE_HEIGHT_PX,
      }}
    >
      <div
        className="pdf-page__inner"
        style={{
          padding: PDF_PAGE_PADDING_PX,
        }}
      >
        {children}
      </div>
    </div>
  );
}
